import View from "./view.js";
import FirstPersonViewport from "../viewports/first-person-viewport.js";
import FirstPersonController from "../controllers/first-person-controller.js";
export default class FirstPersonView extends View {
    static { this.displayName = 'FirstPersonView'; }
    constructor(props = {}) {
        super(props);
    }
    get ViewportType() {
        return FirstPersonViewport;
    }
    get ControllerType() {
        return FirstPersonController;
    }
}
